<template>
    <div>
        <h2>Contact</h2>
        <hr>
        <h3>PI @ AIH Lab</h3>
          <h5><a href="http://liyu95.com" target="_blank">Prof. Li Yu </a></h5>
            <p>
              Affiliation:<br>
              - Department of Computer Science and Engineering, The Chinese University of Hong Kong (CUHK)<br>
              - The CUHK Shenzhen Research Institute (by courtesy)<br>
              Office:<br>
              - Room 106, Ho Sin-Hang Engineering Building, CUHK<br>
              Email:<br>
              - liyuATcse.cuhk.edu.hk<br>
            </p>
    </div>
</template>

<script>
import TextHeader from './TextHeader.vue';

export default {
  components: { TextHeader },

};
</script>
